import UserService from '@/services/UserService';
import NetworkService from '@/services/NetworkService';
export default {
  name: 'Privacy',
  data() {
    return {
      networkInfo: null,
      lastupdate: null
    };
  },
  async mounted() {
    await this.getNetworkInfo();
    await this.getLastUpdate();
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    },
    async getLastUpdate() {
      const info = await NetworkService.getPolicyLastUpdated(10);
      const date = new Date(info.data.updated);
      this.lastupdate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
};